<template>
  <div align="left">
    <p>医院
    <el-select v-model="hospital" filterable placeholder="请选择医疗企业" style="width: 350px">
      <el-option
        v-for="item in hospitals"
        :key="item.value"
        :label="item.label"
        :value="item.value">
      </el-option>
    </el-select>
    </p>
    <p>日期
    <el-date-picker
      v-model="date"
      type="date"
      value-format="yyyy-MM-dd"
      placeholder="选择日期">
    </el-date-picker>
    </p>
    <p>金额（元）
    <el-input-number v-model="amount" style="width: 200px" :min="0" :precision="2" :step="10" :controls="false"></el-input-number>
    </p>
    <p>
      <el-button type="primary" icon="el-icon-circle-plus" :loading="sending" @click="submit" >预存</el-button>
    </p>
  </div>
</template>

<script>
import coder from "./enum.js"
export default {
  methods: {
    submit(){
      if (this.hospital===""){
        this.$alert('请选择医疗企业', '错误', {
          confirmButtonText: '确定'
        });
        return
      }
      if (this.amount===undefined||this.amount===null||this.amount<=0){
        this.$alert('请输入正确的金额', '错误', {
          confirmButtonText: '确定'
        });
        return
      }
      if (this.date===""||this.date===undefined||this.date===null){
        this.$alert('请选择日期', '错误', {
          confirmButtonText: '确定'
        });
        return
      }
      if (this.sending){ return }
      this.sending=true;
      let $this=this;
      window.ws.AddFunc("S2W_DepositRes",function (code,err) {
        $this.sending=false;
        if (code===coder.OK){
          $this.$notify({
            title: '成功',
            message: '预存成功',
            type: 'success'
          });
          $this.amount=0;
        }else{
          $this.$alert(err+'('+code+')', '错误', {
            confirmButtonText: '确定'
          });
        }
      });
      window.ws.Call("W2S_Deposit", this.hospital.split(" ")[0], this.date, parseInt(Math.round(this.amount*100)).toString());
    }
  },
  mounted() {
    let $this=this;
    if (window.hospitals===null||window.hospitals===undefined||window.hospitals.length===0){
      window.ws.AddFunc("S2W_GetHospitalNamesRes",function(list){
        let names = [];
        for(let i=0;i<list.length;i++){
          names.push({value:list[i],label:list[i]})
        }
        $this.hospitals=names;
        window.hospitals=names;
      });
      window.ws.Call("W2S_GetHospitalNames");
    }else{
      this.hospitals=window.hospitals;
    }
  },
  data() {
    return {
      hospital:'',
      date:'',
      amount:0,
      sending:false,
      hospitals:[],
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/DepositInput.vue